import api from "@/services/api.service";
import axios from "axios";
import { ActionTree } from "vuex";
import { AlarmAction, ResponsesState, Response, ResponseTestResult } from "./types";
import {  RootState } from "../types";
import { DeviceChange, UpdateType } from "../../store/devices/types";

export const actions: ActionTree<ResponsesState, RootState> = {
	async fetchResponses({ commit, state }, { cancelToken, serverId }: { cancelToken: any, serverId: number }) {
		if (state.filter === "") {
			const { data } = await api.fetchResponses(state.pageIndex, state.pageSize, state.filter, serverId, cancelToken);

			commit("setResponses", data);

			if (state.pageSize > data.length) {
				commit("setAllResponsesRetrieved", true);
			}
		} else {
			const response = await api.fetchResponses(state.filterPageIndex, state.pageSize, state.filter, serverId, cancelToken);

			if(!response) return;

			commit("setFilteredResponses", response.data);

			if (state.pageSize > response.data.length) {
				commit("setAllFilteredResponsesRetrieved", true);
			}
		}
	},
	async refreshResponses({ commit, state }) {
		commit("setResponseTableIsBusy", true);

		if (state.filter === "") {
			const pageSize = state.responses.length;

			commit("resetResponses");

			const { data } = await api.fetchResponses(state.pageIndex, pageSize, state.filter, 0, null);

			commit("setResponses", data);
		} else {
			const pageSize = state.filteredResponses.length;

			commit("resetFilteredResponses");

			const { data } = await api.fetchResponses(state.filterPageIndex, pageSize, state.filter, 0, null);

			commit("setFilteredResponses", data);
		}

		commit("setResponseTableIsBusy", false);
	},
	async refreshResponsesFromChanges({ commit }, deviceChanges: DeviceChange[]): Promise<void> {
		// responses updated
		let updatedResponses = deviceChanges.filter(function (obj){
			return obj.updateType === UpdateType.Update;
		}).map(u => u.updatedOrAddedResponse);

		if (updatedResponses != null && updatedResponses.length > 0) {
			commit("updateResponses", updatedResponses);
		}

		// responses removed
		let deletedResponses = deviceChanges.filter(function (obj){
			return obj.updateType === UpdateType.Delete;
		}).map(u => u.deviceId);

		if (deletedResponses != null && deletedResponses.length > 0) {
			commit("deleteResponses", deletedResponses);
		}
	},
	async createNewResponse({ commit }, response: Response) {
		const { data } = await api.createNewResponse(response);

		if (data && data.responseID > 0) {
			commit("addNewResponses", data);
			return true;
		} else {
			commit("setfailedResponse", data);
			return false;
		}
	},
	async updateResponse({ commit }, response: Response) {
		let { data } = await api.updateResponse(response);
		if (data) {
			commit("updateResponse", data);
		}
	},
	async deleteResponse({ commit }, responseId: number) {
		let { data } = await api.deleteResponse(responseId);
		if (data) {
			commit("deleteResponse", responseId);
		}
	},
	async triggerTestResponse({ commit }, responseId: number) {
		let { data }: { data: ResponseTestResult } = await api.triggerTestResponse(responseId);
		commit("setTriggerTestResponseResult", data);
	},
	async getSupportedAlarmActionTypes({ commit }) {
		const { data } = await api.getSupportedAlarmActionTypes();

		commit("setSupportedAlarmActionTypes", data);
	},
	async getAlarmActions({ commit }, alarmId: number) {
		const { data } = await api.getAlarmActions(alarmId);

		commit("setAlarmActions", data);
	},
	async createAlarmAction({ commit }, alarmAction: AlarmAction) {
		const { data }: { data: AlarmAction } = await api.createAlarmAction(alarmAction);

		commit("addAlarmAction", data);
		commit("setCurrentAlarmAction", null);
	},
	async updateAlarmAction({ commit }, alarmAction: AlarmAction) {
		const { data }: { data: AlarmAction } = await api.updateAlarmAction(alarmAction);

		commit("updateAlarmAction", data);
		commit("setCurrentAlarmAction", null);
	},
	async deleteAlarmAction({ commit }, alarmAction: AlarmAction) {
		const { data }: { data: boolean } = await api.deleteAlarmAction(alarmAction);

		if (data) {
			commit("deleteAlarmAction", alarmAction);
			commit("setCurrentAlarmAction", null);
		}
	},
	async searchResponse({ commit }, searchTerm: string) {
		const cancelTokenSource = axios.CancelToken.source();

		commit("setCancelTokenSource", cancelTokenSource);
		commit("setResponses", await api.responseSearch(cancelTokenSource.token, searchTerm));
	},
	async getResponsesByTitle({ commit }, responseTitles: string[]) {
		const { data } = await api.getResponsesByTitle(responseTitles);
		commit("setResponses", data);
	},
	async getResponseById({ commit }, responseId: number) {
		const { data } = await api.fetchResponse(responseId);
		commit("setCurrentAlarm", data);
	}
};
